/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PRODUCT_TYPE } from 'configs/constants';
import { fetchCurrentPlanDetails } from 'services/api/subscriptionApi';
import { TCurrentPlansState, TPlanList } from 'typings';

export const fetchCurrentPlan = createAsyncThunk(
  'skus/fetchCurrentPlan',
  async (payload: string, thunkAPI) => {
    try {
      const response = await fetchCurrentPlanDetails(payload);
      console.log('current plan Response', response.data);
      return response.data as TPlanList;
    } catch {
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialCurrentPlanState: TCurrentPlansState = {
  currentPlan: null,
  currentPlanCycle: 1,
  currentPlanLevel: 1,
  birdCurrentPlan: null,
  birdCurrentPlanCycle: 1,
  birdCurrentPlanLevel: 1,
  isLoading: false
};

export const currentPlanSlice = createSlice({
  name: 'currentPlan',
  initialState: initialCurrentPlanState,
  reducers: {
    clearCurrentPlanData: (state) => {
      state.currentPlan = null;
      state.currentPlanCycle = 1;
      state.currentPlanCycle = 1;
      state.birdCurrentPlan = null;
      state.birdCurrentPlanCycle = 1;
      state.birdCurrentPlanLevel = 1;
    },
    updatePlanLevelAndCycle: (state, action) => {
      state.currentPlanCycle = action.payload.currentPlanCycle;
      state.currentPlanLevel = action.payload.currentPlanLevel;
    },
    updateBirdPlanLevelAndCycle: (state, action) => {
      state.birdCurrentPlanCycle = action.payload.currentPlanCycle;
      state.birdCurrentPlanLevel = action.payload.currentPlanLevel;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentPlan.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.product_id === PRODUCT_TYPE.HOME_SECURITY) {
          state.currentPlan = action.payload;
          state.currentPlanLevel = action.payload.level;
          state.currentPlanCycle = action.payload.subscription_cycle;
        }
        if (action.payload.product_id === PRODUCT_TYPE.BIRD) {
          state.birdCurrentPlan = action.payload;
          state.birdCurrentPlanLevel = action.payload.level;
          state.birdCurrentPlanCycle = action.payload.subscription_cycle;
        }
      })
      .addCase(fetchCurrentPlan.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCurrentPlan.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearCurrentPlanData } = currentPlanSlice.actions;

export default currentPlanSlice.reducer;
